import { ApwError, GqlError, PxError } from "./GqlError";
import { ErrorCodes } from "../__generated__/auth-gate";
var retryIntervals = [1, 3, 5, 7];
export function retry(p, shouldRetry) {
  var count = 0;
  var handle;
  return run();
  function run() {
    clearTimeout(handle);
    return new Promise(function (resolve, reject) {
      p().then(resolve, function (err) {
        var interval = retryIntervals[count++] * 1000;
        if (!retryIntervals[count - 1]) {
          reject(err);
          return;
        }
        if (shouldRetry(err)) {
          handle = setTimeout(function () {
            run().then(resolve, reject);
          }, interval);
        } else {
          reject(err);
        }
      });
    });
  }
}
export function apwRetry(p) {
  return retry(p, function (e) {
    if (e instanceof ApwError) {
      return e.code == ErrorCodes.slow_down;
    }
    if (e instanceof PxError) {
      return false;
    }
    if (e instanceof GqlError) {
      return e.extensions.shouldRetry;
    }
    return true;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/utils/retry.js
// module id = 5473
// module chunks = 11